import { LoadState } from "../../constants/enums";
import { IActionItem, IActionItemsState } from "./actionItem.types";

export const initialActionItem: IActionItem = {
  action_item_unique_id: 0,
  action_item_uuid: "",
  conversation_id: "",

  name: "",
  mobile_no: "",
  country_code: "1",
  country_iso_code: "",
  email: null,
  additional_contact_number: [],
  relation_with_customer: null,
  customer_relative_name: null,

  item: "",
  category_code: "",
  category_name: "",
  priority: "HOT",
  status: "ACTIVE",
  description: "",
  recommendation: null,
  remarks: null,
  actual_status: null,

  event_uuid: null,
  other_event_name: null,
  event_time: null,
  event_time_uuid: null,
  preferred_venue: null,
  preferred_venue_uuid: null,
  date_of_visit: null,
  function_date: null,
  function_month: null,
  function_year: null,
  booking_date: null,
  number_of_rooms: null,
  number_of_guests: null,

  estimated_rough_revenue: null,
  guest_budget: null,
  payment_mode: null,

  source: "Direct",
  lead_source_uuid: null,
  drive_status_uuid: null,
  lead_behaviour: null,
  dead_behaviour: null,
  cancellation_dead_reason: null,
  followup_date: null,
  is_archived: null,

  assigned_to_uuid: null,
  assigned_to_name: null,
  handled_by_employee: null,
  handled_by_employee_uuid: null,

  extras: null,
  meta_json: null,
  form_filled: null,

  company_outlet_uuid: "",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
  username: null,
  tk_assigned_to_name: null,
};

export const initialActionItemState: IActionItemsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  actionItem: {
    data: initialActionItem,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
